import { useEffect, useState } from 'react'

import type { AutoDeliveryConfig, ShopConfig } from '../../common/config'
import type { ErrorMessageContent } from '../../common/cart-management/CartErrorMessageDialog'
import {
  fetchContainerContent,
  setDialogConfig
} from '../../common/dialog-configuration'

interface UseDialogsParams {
  shopConfig: ShopConfig
  autoDeliveryConfig: AutoDeliveryConfig | undefined
  errorMessageContent: ErrorMessageContent
}

export const useDialogs = ({
  shopConfig,
  autoDeliveryConfig,
  errorMessageContent
}: UseDialogsParams) => {
  const [dialogErrorMessageIsOpen, setDialogErrorMessageIsOpen] =
    useState(false)
  const [dialogNotifyMeIsOpen, setDialogNotifyMeIsOpen] = useState(false)
  const [notifyMeContent, setNotifyMeContent] = useState({})
  const [
    autoDeliveryUneligibilityDialogContent,
    setAutoDeliveryUneligibilityDialogContent
  ] = useState<Record<string, unknown>>({})
  const [
    isAutoDeliveryUneligibilityDialogOpen,
    setIsAutoDeliveryUneligibilityDialogOpen
  ] = useState(false)

  const configCartErrorMessageDialog = {
    errorMessageContent,
    dialogErrorMessageIsOpen,
    setDialogErrorMessageIsOpen
  }

  const cNotifyMeDialog = setDialogConfig(
    dialogNotifyMeIsOpen,
    setDialogNotifyMeIsOpen,
    shopConfig?.notifyMeDialogTitle ?? '',
    shopConfig?.closeAriaLabel ?? '',
    () => fetchContainerContent(shopConfig?.notifyMeXF, setNotifyMeContent)
  )

  const autoDeliveryUneligibilityDialog = setDialogConfig(
    isAutoDeliveryUneligibilityDialogOpen,
    () => {},
    autoDeliveryConfig?.alreadySubscribedDialogTitle ?? '',
    autoDeliveryConfig?.alreadySubscribedDialogCloseButtonAriaLabel ?? '',
    undefined,
    false
  )

  // Fetch notify-me XF content on mount
  useEffect(() => {
    fetchContainerContent(shopConfig?.notifyMeXF, setNotifyMeContent)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    dialogErrorMessageIsOpen,
    setDialogErrorMessageIsOpen,
    dialogNotifyMeIsOpen,
    setDialogNotifyMeIsOpen,
    notifyMeContent,
    isAutoDeliveryUneligibilityDialogOpen,
    setIsAutoDeliveryUneligibilityDialogOpen,
    autoDeliveryUneligibilityDialogContent,
    setAutoDeliveryUneligibilityDialogContent,
    configCartErrorMessageDialog,
    cNotifyMeDialog,
    autoDeliveryUneligibilityDialog
  }
}
